import "../jsdoc/NavItem";
import NavigationService from "../services/NavigationService";

export default class ContextPane extends HTMLElement {

    connectedCallback() {

        this.classList.add("context-menu", "global-navigation-panel", "main-nav");
        this.setAttribute("tabindex", "-1");
        this.addEventListener("click", this.handleClick);

        const navService = new NavigationService();

        navService.getChildren(this.pageId).then(data => this.render(data));

    }

    disconnectedCallback() {
        this.removeEventListener("click", this.handleClick);
    }

    handleClick = (e) => {
        const element = e.target;

        const isCurrentLevelLink = element.dataset.pageId === this.pageId;
        const isUpLink = element.matches(".nav-link.nav-link-up");

        /* 
         * If the clicked element is the first nav item (the page link for the 
         * current menu level) or if the element has no child pages return and 
         * just follow the links href.
        */
        if (!isUpLink && (isCurrentLevelLink || element.dataset.hasChildren !== "true")) {
            return;
        }

        e.preventDefault();

        if (element.matches(".nav-link.nav-link-up")) {
            const pageId = element.getAttribute("data-page-id");
            const isChild = false;
            const navigateEvent = new CustomEvent("navigate", { detail: { pageId, isChild } });
            this.dispatchEvent(navigateEvent);
        }
        else if (element.matches(".nav .nav-link")) {
            const pageId = element.getAttribute("data-page-id");
            const isChild = true;
            const navigateEvent = new CustomEvent("navigate", { detail: { pageId, isChild } });
            this.dispatchEvent(navigateEvent);
        }

    }

    /**
     * 
     * @param {Array.<NavItem>} data
     */
    render(data) {
        const activeClass = data.activePageId === (data.parentPage ? data.parentPage.id.toString() : null) || data.parentPage === null ? "active" : "";
        const hasParentPage = data.parentPage !== null && data.parentPage.parentId !== null;
        this.innerHTML = `
            ${hasParentPage ? `<a href="${data.parentPage.url}" data-page-id="${data.parentPage.id}" class="nav-link nav-link-up ${activeClass}" role="button">${this.getIcon("chevron-left")} ${data.parentPage.name}</a>` : ""}
            <ul class="nav flex-column">
                ${hasParentPage ? this.getItemHtml(data.currentPage, data.activePageId) : ""}
                ${this.getItemsHtml(data.childPages, data.activePageId)}
            </ul>`;
            
        if (data.search) {
            this.innerHTML = this.innerHTML + `<a href=${data.search.url} class="nav-link search flex-end" role="button"> ${this.getIcon("search", "me-1")} ${data.search.name}</a>`;
        }
        if (data.login) {
            this.innerHTML = this.innerHTML + `<a href=${data.login.url} class="nav-link active flex-end" role="button">${data.login.name}</a>`;
        }
    }

    /**
     * 
     * @param {Array.<NavItem>} items
     * @param {number} activePageId
     */
    getItemsHtml(items, activePageId) {
        return Array.from(items).map(item => this.getItemHtml(item, activePageId)).join("");
    }

    /**
     * 
     * @param {NavItem} item
     * @param {number} activePageId
     */
    getItemHtml(item, activePageId) {
        const activeClass = item.id === activePageId.toString() ? "active" : "";
        const subItem = item.isSubItem ? "subitem" : "";

        return `<li class="nav-item">
            <a href="${item.url}" data-page-id="${item.id}" data-has-children="${item.hasChildren}" class="nav-link ${activeClass} ${subItem}" role="button">
                ${item.isProtected ? (item.isLocked ? this.getIcon("padlock-closed", "me-1") : this.getIcon("padlock-open", "me-1")) : ""}
                ${item.name}
                ${!item.isCurrentPage && item.hasChildren ? this.getIcon("chevron-right") : ""}
            </a>
        </li>`;
    }

    /**
     * 
     * @param {string} name
     */
    getIcon(name, className = "") {
        return `<svg class=\"icon-${name} icon ${className}\"><use xlink:href=\"/Static/bundles/Icons/sprites.svg#icon-${name}\"></use></svg>`;
    }

    get pageId() {
        return this.dataset.pageId;
    }

    get parentId() {
        return this.dataset.parentId;
    }

    get returnUrl() {
        return this.dataset.returnurl;
    }

}

customElements.define('context-pane', ContextPane);